// extracted by mini-css-extract-plugin
export var adjacentSlide = "_nf-9";
export var arrowButtonContainer = "_nf-5";
export var arrowButtonIcon = "_nf-6";
export var carouselArrowButton = "_nf-2";
export var carouselElementContainer = "_nf-1";
export var currentSlide = "_nf-8";
export var left = "_nf-3";
export var otherSlide = "_nf-a";
export var productCarouselContainer = "_nf-0";
export var right = "_nf-4";
export var sliderOverflow = "_nf-7";